export default {
    _formElement: null,
    _isLocked: false,
    _originalCallback: undefined,
    _hardLockMessage: 'The form is not ready yet, please wait for all form fields to be ready.',
    _softLockMessage: 'The form is not ready yet, do you want to submit anyway?',

    init() {
        this._isLocked = false;
    },

    lock() {
        // Must re-fetch element otherwise onsubmit is abused by some jquery script
        this._formElement = document.getElementById("modelForm");

        if (!this._checkElement()) {
            return;
        }

        if (this._isLocked) {
            console.warn('modelForm already locked');
            return;
        }

        const self = this;

        /**
         * We are writing to `onsubmit` because `addEventListener` will only
         * work when the user triggers a submit, but we trigger the form
         * submit by code. To not lose any other onsubmit hooks we store the original
         * callback and trigger that before triggering our own code.
         */
        this._originalCallback = this._formElement.onsubmit;
        this._formElement.onsubmit = function (event) {
            if (self._originalCallback) {
                self._originalCallback(event)
            }

            event.preventDefault();
            self._showMessage();
            return false;
        };

        this._isLocked = true;
    },

    unlock () {
        // Must re-fetch element otherwise onsubmit is abused by some jquery script
        this._formElement = document.getElementById("modelForm");

        if (!this._checkElement()) {
            return;
        }

        /**
         * Restore the original callback in `onsubmit` to revert to the
         * state before locking the
         */
        this._formElement.onsubmit = this._originalCallback;
        this._isLocked = false;
    },

    _showMessage () {
        alert(this._hardLockMessage);
    },

    _checkElement() {
        if (!this._formElement) {
            console.error('Can not use modelFormLocker because element is not found.');
            return false;
        }

        return true;
    }
}